import { createAction } from 'redux-act';
import fetch from 'axios';
import { notify } from 'reapop';
import { push } from 'react-router-redux';
import loginUser from './login';

/**
 * Create the action
 */

const request = createAction('REGISTER_REQUEST');
const success = createAction('REGISTER_SUCCESS');
const error = createAction('REGISTER_ERROR');

function registerUser(data) {
  return function (dispatch) {
    // Dispatch the request action
    dispatch(request);

    if (data.is_trial_account) {
      return fetch
        .post('/api/auth/trial', data)
        .then(({ response }) => {
          dispatch(
            notify({
              message:
                'Proefaccount aangemaakt, u ontvangt een mail met instructies!',
              dismissible: true,
              status: 'success',
              position: 'tc',
            })
          );

          // Dispatch success action
          dispatch(success(response));
        })
        .then(() => dispatch(push('/inloggen')))
        .catch((err) => {
          dispatch(
            notify({
              message: 'Zorg ervoor dat alle velden zijn ingevuld.',
              dismissible: true,
              status: 'error',
              position: 'tc',
            })
          );
          dispatch(error(err));
          throw err;
        });
    }

    const route = data.isExtern
      ? '/api/auth/register-extern'
      : '/api/auth/register';

    return fetch
      .post(route, data)
      .then(({ response }) => {
        dispatch(
          notify({
            message: 'Account aangemaakt!',
            dismissible: true,
            status: 'success',
            position: 'tc',
          })
        );

        // Dispatch success action
        dispatch(success(response));
      })
      .then(() => dispatch(loginUser(data)))
      .then(() => dispatch(push('/inloggen')))
      .catch((err) => {
        dispatch(
          notify({
            message: 'Zorg ervoor dat alle velden zijn ingevuld.',
            dismissible: true,
            status: 'error',
            position: 'tc',
          })
        );
        dispatch(error(err));
        throw err;
      });
  };
}

/**
 * Export the components
 */

export { registerUser as default };
export { request, success, error };
